// extracted by mini-css-extract-plugin
module.exports = {"sandboxed-iframe":"sandboxed-js-embed_sandboxed-iframe__HjFO9"};